{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              43.215157073136766,
              -0.9370118743412092
            ],
            [
              43.215157073136766,
              -10.925871016596247
            ],
            [
              58.65445686563936,
              -10.925871016596247
            ],
            [
              58.65445686563936,
              -0.9370118743412092
            ],
            [
              43.215157073136766,
              -0.9370118743412092
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}